module.exports = __webpack_public_path__ + "media/images/icons/mastercard_small-e020aa6c8b4c0ee60d67c88c8ee9bdde.svg";